import { render, staticRenderFns } from "./EditFormText.vue?vue&type=template&id=b10ba5c4"
import script from "./EditFormText.vue?vue&type=script&lang=js"
export * from "./EditFormText.vue?vue&type=script&lang=js"
import style0 from "./EditFormText.vue?vue&type=style&index=0&id=b10ba5c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports